/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Driver and constructor stats for every F1 Fantasy season since 2023. Use Race Results for finishing-position trends, or switch to Fantasy Stats to sort by PPM (Points Per Million) — the best measure of value in the game.`)
};

const es_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estadísticas de pilotos y constructores para cada temporada de F1 Fantasy desde 2023. Usa Resultados de Carrera para tendencias de posición, o cambia a Fantasy Stats para ordenar por PPM (Puntos Por Millón) — la mejor medida de valor en el juego.`)
};

const de_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrer- und Konstrukteur-Statistiken für jede F1-Fantasy-Saison seit 2023. Nutze Rennergebnisse für Platzierungstrends oder wechsle zu Fantasy Stats, um nach PPM (Punkte pro Million) zu sortieren — das beste Maß für den Wert im Spiel.`)
};

const nl_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coureurs- en constructeursstatistieken voor elk F1 Fantasy-seizoen sinds 2023. Gebruik Raceresultaten voor positietrends, of schakel naar Fantasy Stats om te sorteren op PPM (Punten Per Miljoen) — de beste maatstaf voor waarde in het spel.`)
};

const fr_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiques des pilotes et constructeurs pour chaque saison F1 Fantasy depuis 2023. Utilisez les Résultats de Course pour les tendances de position, ou basculez vers Fantasy Stats pour trier par PPM (Points Par Million) — la meilleure mesure de valeur dans le jeu.`)
};

const it_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statistiche piloti e costruttori per ogni stagione di F1 Fantasy dal 2023. Usa i Risultati Gara per le tendenze di piazzamento, oppure passa a Fantasy Stats per ordinare per PPM (Punti Per Milione) — la migliore misura di valore nel gioco.`)
};

const pt_br2_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de pilotos e construtores para cada temporada de F1 Fantasy desde 2023. Use Resultados de Corrida para tendências de posição, ou mude para Fantasy Stats para ordenar por PPM (Pontos Por Milhão) — a melhor medida de valor no jogo.`)
};

const pt_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estatísticas de pilotos e construtores para cada época de F1 Fantasy desde 2023. Use Resultados de Corrida para tendências de posição, ou mude para Fantasy Stats para ordenar por PPM (Pontos Por Milhão) — a melhor medida de valor no jogo.`)
};

const ja_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023年以降の全F1ファンタジーシーズンのドライバーとコンストラクターの統計。レース結果で順位傾向を確認するか、Fantasy Statsに切り替えてPPM（ポイント・パー・ミリオン）でソート — ゲーム内で最も良いバリュー指標です。`)
};

const zh_f1_stats_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2023年以来每个F1梦幻赛季的车手和车队统计数据。使用比赛成绩查看排名趋势，或切换到梦幻统计按PPM（每百万积分）排序 — 游戏中最佳的价值衡量标准。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_intro", locale)
	if (locale === "en") return en_f1_stats_intro(inputs)
	if (locale === "es") return es_f1_stats_intro(inputs)
	if (locale === "de") return de_f1_stats_intro(inputs)
	if (locale === "nl") return nl_f1_stats_intro(inputs)
	if (locale === "fr") return fr_f1_stats_intro(inputs)
	if (locale === "it") return it_f1_stats_intro(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_intro(inputs)
	if (locale === "pt") return pt_f1_stats_intro(inputs)
	if (locale === "ja") return ja_f1_stats_intro(inputs)
	return zh_f1_stats_intro(inputs)
};